import Login from "./Login";
import "./style.css";

const Authentication = () => {
	return (
		<div className="login-page">
			<Login />
		</div>
	);
};
export default Authentication;
